import type { HTMLAttributes, ReactNode } from "react";

type Tone = "default" | "accent";

interface Props extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  title?: ReactNode;
  action?: ReactNode;
  tone?: Tone;
}

export function Card({
  title, action, tone = "default", className = "", children, ...rest
}: Props) {
  const accent = tone === "accent";
  return (
    <div
      className={[
        "rounded-tile border p-[22px] box-border",
        accent ? "bg-fh-sage border-fh-gold" : "bg-white border-fh-gold",
        className,
      ].join(" ")}
      {...rest}
    >
      {(title || action) && (
        <div className="flex items-center justify-between mb-3.5">
          {title && (
            <h3 className="font-serif text-[16px] font-normal text-fh-ink m-0">{title}</h3>
          )}
          {action && (
            <span className="text-[12px] font-semibold text-fh-green cursor-pointer">{action}</span>
          )}
        </div>
      )}
      {children}
    </div>
  );
}

// Larger card used for the centered auth layout.
export function AuthCard({ children }: { children: ReactNode }) {
  return (
    <div className="w-full max-w-[412px] bg-white border border-fh-border rounded-card shadow-card px-[34px] py-[36px] box-border">
      {children}
    </div>
  );
}
